function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.19696 14.5404L7 14.456L6.80304 14.5404L1.19696 16.943C0.867025 17.0844 0.5 16.8424 0.5 16.4835V2C0.5 1.17614 1.17614 0.5 2 0.5H12C12.8239 0.5 13.5 1.17614 13.5 2V16.4835C13.5 16.8424 13.133 17.0844 12.803 16.943L7.19696 14.5404Z",
  fill: "transparent",
  stroke: "currentColor"
});
function SvgWatchlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlist);
export default __webpack_public_path__ + "static/media/watchlist.1afca03a.svg";
export { ForwardRef as ReactComponent };